import React from 'react';
import './sectionOne.css';
import section_img from '../../assets/section-img.png'
import { useHistory } from 'react-router';

function SectionOne() {

    const history = useHistory();

    const handleClick = () => {
        history.push('about')
    }
    return (
        <div className="sectionOne__main">
            <div data-aos="fade-left" className="sectionOne__left">
                    <img src={section_img} alt="" />
            </div>
            <div className="sectionOne__right">
                <div data-aos="fade-down"
                data-aos-duration="500"  className="tagline"> About Us</div>
                <div data-aos="fade-up" className="head__two">
                Support Children Developing Skills
                </div>
                <div data-aos="fade-right" className="paragraph">
                Education is the process of facilitating learning, or the acquisition of knowledge, skills, values, morals, beliefs, and habits.
                </div>
                <button data-aos="fade-left" className="secondary__button" onClick={handleClick}>
                    About Us
                </button>
            </div>
        </div>
    )
}

export default SectionOne
